import { render, staticRenderFns } from "./ModalAtualizarProcesso.vue?vue&type=template&id=2da9f1a4&scoped=true"
import script from "./ModalAtualizarProcesso.vue?vue&type=script&lang=ts"
export * from "./ModalAtualizarProcesso.vue?vue&type=script&lang=ts"
import style0 from "./ModalAtualizarProcesso.vue?vue&type=style&index=0&id=2da9f1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9f1a4",
  null
  
)

export default component.exports